import pairAbi from "@abi/Pair.json";
import defaultConfig from "@config";
import type { Address } from "viem";
import { useReadContract } from "wagmi";
export const useVPNDPrice = () => {
	// Was facing issues with useReadContracts, that is why using individual reads.

	const { data: VpndReserves } = useReadContract({
		abi: pairAbi,
		address: defaultConfig.pairAddress.vpndPair as Address,
		args: [],
		functionName: "getReserves",
	});

	const { data: AVAXReserves } = useReadContract({
		abi: pairAbi,
		address: defaultConfig.pairAddress.avaxPair as Address,
		args: [],
		functionName: "getReserves",
	});
	// @ts-expect-error: TODO
	const reserve0 = VpndReserves?.map((value) => Number(value?.toString()));
	// @ts-expect-error: TODO
	const reserve1 = AVAXReserves?.map((value) => Number(value?.toString()));

	const vpndPriceInAvax = reserve0 ? +reserve0[1] / +reserve0[0] : 0;
	const avaxPrice = reserve1 ? +reserve1[1] / 1e6 / (+reserve1[0] / 1e18) : 0;

	return (vpndPriceInAvax * avaxPrice).toString() ?? "0";
};
